// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivityIconBody_container__QW0wG"};